import { toPdf, toPdf_pages, toPdfBackend } from "./toPdf";
import { getCookie } from "../utils/cookies";
import { authFetchRequest } from "../utils/api"; // Make sure this path is correct
import { alertC } from "./dialogService";
import { USE_PDF_SERVER } from "../constants";

export const sendEmailWithPdf = async ({
  simplePdf = true,
  recipient,
  recipientName = "",
  subject = "The current quote from Eticom Doors",

  message =
  "Hi,\n\n" +
  "Please find your quote PDF attached.\n\n" +
  "If you have any questions or need further assistance, feel free to reach out to us.\n\n" +
  "Best regards,\n" +
  "The Eticom Team",

  container = ".view-details",
  filename = "Quote",
  scale = 1.2, // <-- NEW
}) => {
  try {
    const today = new Date().toISOString().split("T")[0];
    const fullFilename = `${filename}-${today}.pdf`;

    // 1. Generate PDF as Blob
    // Two pipelines, picked at runtime by the USE_PDF_SERVER flag in
    // constants.js. The backend (Playwright) path produces vector PDFs
    // an order of magnitude smaller than the html2canvas raster route
    // and is unaffected by the App.js DPI transform.
    let pdfBlobTemp;
    if (USE_PDF_SERVER) {
      pdfBlobTemp = await toPdfBackend({
        container,
        filename: fullFilename.replace(/\.pdf$/i, ''),
        returnBlob: true,
        format: 'A4',
        // margin: '0' lets pdf-test.css @page rules + .pdf-capture padding
        // control margins consistently with the on-screen Test PDF download.
        margin: '0',
        bodyClass: 'pdf-test-mode',
      });
    } else if (simplePdf) {
        pdfBlobTemp = await toPdf({
            container,
            filename: fullFilename,
            returnBlob: true,
            scale: scale,
        });
    } else {
        pdfBlobTemp = await toPdf_pages({
            container,
            filename: fullFilename,
            returnBlob: true,
            scale: scale,
        });
    }
    const pdfBlob = pdfBlobTemp
    
    // 2. Convert Blob to Base64
    const base64String = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result;
        if (typeof result === "string") {
          resolve(result.split(",")[1]); // Strip data URL prefix
        } else {
          reject(new Error("Failed to convert PDF to base64."));
        }
      };
      reader.onerror = reject;
      reader.readAsDataURL(pdfBlob);
    });

    if (0){
    alertC(
        `recipient: ${recipient}\n` +
        `subject: ${subject}\n` +
        `message: ${message}\n` +
        `filename: ${fullFilename}\n` +
        `file_content (truncated): ${base64String.slice(0, 100)}...`
      );
    }
     

    // 3. Send email request to backend
    const response = await authFetchRequest(
      "/email/send",
      {
        to: recipient,
        subject,
        message,
        filename: fullFilename,
        file_content: base64String,
        recipient_name: recipientName || "",
      },
      "POST",
      {
        Authorization: `Bearer ${getCookie("access_token")}`,
      }
    );

    return response; // Return server response for use in UI
} catch (error) {
    console.error("sendEmailWithPdf error:", error);
  
    // Force stringify any non-enumerable error properties
    let errorMessage;
    try {
      errorMessage = JSON.stringify(error, Object.getOwnPropertyNames(error), 2);
    } catch (e) {
      errorMessage = error.toString();
    }
  
    alertC("sendEmailWithPdf failed:\n" + errorMessage);
  
    return { success: false, error: errorMessage };
  }
  
};
